module.exports = __webpack_public_path__ + "static/media/breakdownTable4.6f916984.png";